export default __webpack_public_path__ + "static/ambetter-f7d5a666541c8c1e5437b0bcb8e2c1aa.svg";